export default __webpack_public_path__ + "static/media/cutterGray.bca63cdb.svg";